import { render, staticRenderFns } from "./FlmInfo.vue?vue&type=template&id=9d2386d8&scoped=true"
import script from "./FlmInfo.vue?vue&type=script&lang=ts"
export * from "./FlmInfo.vue?vue&type=script&lang=ts"
import style0 from "./FlmInfo.vue?vue&type=style&index=0&id=9d2386d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2386d8",
  null
  
)

export default component.exports